import { useNavigate } from 'react-router-dom'; 
import './Cards.css'; 
import { useTranslation } from 'react-i18next';  

export default function Cards({ cardData, cardPaths = {} }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const handleCardClick = (card) => {
        // Check if a specific path is defined for this card type
        const path = cardPaths[card.title];
        
        if (path) {
            navigate(path);
        }
    };
    
    return (
        <>
            {cardData && <div className='cards-section'>
                {cardData.map((card, index) => (
                    <div
                        className={`card-container ${cardPaths[card.title] ? 'cursor-pointer' : ''}`}
                        key={index}
                        onClick={() => handleCardClick(card)}
                    >
                        <div className='card-box' style={{
                            backgroundColor: card.backgroundColor || undefined, // Keep the original behavior
                        }}>
                            <div className='card-content'>
                                <span
                                    className='card-title'
                                    style={{
                                        color: card.titleColor || card.color || '#000000' // Use titleColor if provided, fall back to legacy color prop
                                    }}
                                >
                                    {t(card.title)}
                                </span>
                                <span
                                    className='card-value'
                                    style={{
                                        color: card.valueColor || '#000000' // Use valueColor if provided, default to black
                                    }}
                                >
                                    {card.value}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>}
        </>
    );
}